module.exports = __webpack_public_path__ + "img/new2-1.50580f89.jpg";